export * from "./EntitlementsDetailsList";
